import { Dispatch } from '../components/architecture/frontend/index'

import { map, tap } from 'rxjs/operators'

import _ from 'lodash'

const createBufferObject = (type) => {

  let rawData = []
  let bufferData = []
  let loading = true
 // const data = []

  const computeData = () => {
    return rawData?.map(raw => {
      const clone = _.cloneDeep(raw)
      _.merge(clone, _.find(bufferData, buffer => buffer.id === clone.id))
      return clone
      //return result ? result : raw
    }) ?? []
  }

  Dispatch.getAction('__.buffer.setLoading.' + type)
    .pipe(
      tap(e => {
        loading = true
        rawData = []
        bufferData =[]
      }),
      map(e => ({
        rawData: rawData,
        bufferData,
        loading,
        data: computeData()
      }))
    )
    .subscribe(e => Dispatch.nextState(type, e))

  Dispatch.getAction('__.buffer.setRaw.' + type)
  .pipe(
    tap(e => {
      rawData = e
      loading = false
    }),
    map(e => ({
      rawData: e,
      bufferData,
      loading,
      data: computeData()
    }))
  )
  .subscribe(e => Dispatch.nextState(type, e))

Dispatch.getAction('__.buffer.setRawAndClearBuffer.' + type)
  .pipe(
    tap(e => {
      rawData = e
      bufferData = []
      loading = false
    }),
    map(e => ({
      rawData: e,
      bufferData,
      loading,
      data: computeData()
    }))
  )
  .subscribe(e => Dispatch.nextState(type, e))

Dispatch.getAction('__.buffer.setBuffer.' + type)
    .pipe(
      tap(e => {
        const index = _.findIndex(bufferData, data => data.id === e.id)
        if (index === -1) {
          bufferData = [...bufferData, {id: e.id, [e.object]: e.value}]
        }
        else {
          bufferData = [...bufferData]
          bufferData[index][e.object] = e.value
        }
      }),
      map(e => ({
        rawData,
        bufferData: [...bufferData],
        loading,
        data: computeData()
      }))
    )
    .subscribe(e => Dispatch.nextState(type, e))

Dispatch.getAction('__.buffer.clearBuffer.' + type)
    .pipe(
      tap(e => {
          bufferData = []
      }),
      map(e => ({
        rawData,
        bufferData: [...bufferData],
        loading,
        data: computeData()
      }))
    )
    .subscribe(e => Dispatch.nextState(type, e))
}

export default createBufferObject